import React from "react";

const FormEvent = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <form onClick={handleSubmit}>
      <input type="text" placeholder="Your e-mail here" />
      <button>Free Estimation</button>
    </form>
  );
};

export default FormEvent;
